import { Col, Row } from "react-bootstrap";

const ShadowCard = ({ title, children, colSize = 3, className }) => {
  return (
    <Col md={colSize} className={className}>
      <Row>
        <Col className="radar-topics" data-printable="true" id="section-20">
          <div className="general-info">
            <div className="profile-box-title">
              <p>{title}</p>
            </div>
            {children}
          </div>
        </Col>
      </Row>
    </Col>
  );
};

export default ShadowCard;
